// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"656":"f4ae908f","914":"695b785c"}[chunkId] + ".chunk.css";
};